import React from 'react';

export interface IconTiktokProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconTiktok: React.FC<IconTiktokProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M18.0075 6.84956C17.8829 6.78677 17.7616 6.71794 17.6441 6.64332C17.3023 6.423 16.9889 6.1634 16.7107 5.87011C16.0146 5.09352 15.7547 4.30568 15.6589 3.75409H15.6627C15.5827 3.29624 15.6158 3 15.6208 3H12.4504V14.9537C12.4504 15.1141 12.4504 15.2728 12.4434 15.4295C12.4434 15.449 12.4415 15.467 12.4404 15.488C12.4404 15.4966 12.4404 15.5056 12.4384 15.5146V15.5214C12.405 15.9503 12.264 16.3646 12.0278 16.7279C11.7916 17.0912 11.4675 17.3923 11.084 17.6048C10.6842 17.8265 10.2321 17.9428 9.77217 17.9423C8.295 17.9423 7.09781 16.7678 7.09781 15.3174C7.09781 13.867 8.295 12.6925 9.77217 12.6925C10.0518 12.6923 10.3297 12.7352 10.5955 12.8196L10.5994 9.67204C9.7923 9.57039 8.97237 9.63293 8.19131 9.85572C7.41025 10.0785 6.68502 10.4567 6.06138 10.9665C5.51492 11.4294 5.05551 11.9818 4.70382 12.5988C4.56999 12.8238 4.06504 13.7278 4.00389 15.1951C3.96543 16.028 4.22194 16.8908 4.34424 17.2474V17.2549C4.42116 17.4649 4.7192 18.1815 5.20492 18.7856C5.59659 19.2702 6.05933 19.6958 6.57825 20.0489V20.0414L6.58594 20.0489C8.12079 21.0658 9.82255 20.9991 9.82255 20.9991C10.1171 20.9875 11.104 20.9991 12.2246 20.4813C13.4676 19.9072 14.1752 19.0518 14.1752 19.0518C14.6273 18.5408 14.9867 17.9583 15.2382 17.3295C15.5251 16.5942 15.6208 15.7122 15.6208 15.3598V9.01807C15.6593 9.04057 16.1715 9.37093 16.1715 9.37093C16.1715 9.37093 16.9095 9.83216 18.061 10.1325C18.887 10.3463 20 10.3913 20 10.3913V7.32241C19.61 7.36366 18.8182 7.24366 18.0075 6.84956Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconTiktok;
